/** @jsx jsx */

import { css, jsx } from '@emotion/core';

import { CHARLES_BLUE, WHITE } from '@cityofboston/react-fleet';

interface Props {
  name: 'birth' | 'marriage';
}

export default function CertificateIcon(props: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 147 97"
      aria-hidden="true"
      focusable="false"
      overflow="visible"
      css={ICON_STYLING}
    >
      {icons[props.name]}
    </svg>
  );
}

const ICON_STYLING = css({
  fill: WHITE,
  color: CHARLES_BLUE,
  stroke: 'currentColor',
  strokeWidth: 3,

  '.frame': {
    strokeWidth: 3.5,
  },

  '.lines': {
    strokeWidth: 3.75,
  },

  '.birth': {
    stroke: 'none',
  },

  '.marriage': {
    stroke: 'none',
  },
});

const icons = {
  birth: (
    <>
      <rect x="2" y="2" width="143" height="93" />

      <g className="lines">
        <line x1="77" y1="16.3" x2="132" y2="16.3" />
        <line x1="77" y1="31.8" x2="132" y2="31.8" />
        <line x1="77" y1="47.2" x2="132" y2="47.2" />
        <line x1="77" y1="62.6" x2="132" y2="62.6" />
        <line x1="77" y1="78" x2="132" y2="78" />
      </g>

      <g transform="translate(-80 -31) scale(1.1 1.1)" className="birth">
        <path
          fill="currentColor"
          d="M120.1 91c-.3-1.8-1-3.5-1.7-5.3-.3-.7-.6-1.4-1.1-2-.4-.5-.8-.9-1.2-1.4-4.1-4.7-5-12.8-.7-17.7 1.7-2 1.6-7.2 0-9.2-.8-1-2-1.6-3.2-2.1-4.1-1.5-8.9-1.3-12.9.6-2.5 1.2-3.7 2.7-4 5.4-1.5 13.1 5.3 41.4 17.6 41.4 3 0 5.4-2.2 6.5-4.9.8-1.6.9-3.2.7-4.8z"
        />

        <ellipse
          transform="rotate(34.386 118.151 48.032)"
          fill="currentColor"
          cx="118.2"
          cy="48"
          rx="3.2"
          ry="4.4"
        />

        <ellipse
          transform="rotate(19.881 111.01 46.555)"
          fill="currentColor"
          cx="111"
          cy="46.6"
          rx="2.1"
          ry="2.8"
        />

        <ellipse
          transform="rotate(8.583 105.263 46.468)"
          fill="currentColor"
          cx="105.3"
          cy="46.5"
          rx="2.1"
          ry="2.8"
        />

        <ellipse
          transform="rotate(-13.639 99.556 47.887)"
          fill="currentColor"
          cx="99.5"
          cy="47.9"
          rx="2.1"
          ry="2.8"
        />

        <ellipse
          transform="rotate(-22.382 94.858 51.887)"
          fill="currentColor"
          cx="94.9"
          cy="51.9"
          rx="1.9"
          ry="2.6"
        />
      </g>
    </>
  ),
  marriage: (
    <svg viewBox="0 0 276 137">
      <g
        transform="translate(-80 -55) scale(1.7 1.7)"
        className="marriage"
        overflow="visible"
      >
        <path
          fill="currentColor"
          d="M128 109.1c-17.1 0-31-13.9-31-31s13.9-31 31-31 31 13.9 31 31c0 8.5-3.4 16.5-9.6 22.4-.6.6-1.5.6-2.1 0-.6-.6-.6-1.5 0-2.1 5.6-5.3 8.6-12.5 8.6-20.2 0-15.5-12.6-28-28-28s-28 12.6-28 28 12.6 28 28 28c4.9 0 9.7-1.3 14-3.7.7-.4 1.6-.2 2 .5.4.7.2 1.6-.5 2-4.6 2.7-9.9 4.1-15.4 4.1zm0-6.1c-13.7 0-24.9-11.2-24.9-24.9s11.2-24.9 24.9-24.9 24.9 11.2 24.9 24.9c0 7.3-3.2 14.3-8.8 19-.6.5-1.6.5-2.1-.2-.5-.6-.5-1.6.2-2.1 4.9-4.2 7.8-10.3 7.8-16.7 0-12.1-9.8-21.9-21.9-21.9s-21.9 9.8-21.9 21.9c0 12.1 9.8 21.9 21.9 21.9 3 0 5.9-.6 8.6-1.8.8-.3 1.6 0 2 .8.3.8 0 1.6-.8 2-3.1 1.3-6.4 2-9.9 2z"
        />
        <path d="M85.2 63.6c47.2 4.1 112.9 0 115 0 2.9 0 5.2 5.7 5.2 12.8 0 7.1-2.3 12.8-5.2 12.8-1.5 0-62.6-3.7-115 0" />
        <path
          fill="currentColor"
          d="M85.2 90.7c-.8 0-1.4-.6-1.5-1.4-.1-.8.6-1.5 1.4-1.6 30.5-2.2 70.7-2.2 113.1-.1 1.2.1 1.9.1 2.1.1 1.5 0 3.7-4.5 3.7-11.3s-2.2-11.3-3.7-11.3c-.2 0-1.5.1-3 .1-58 2.9-93 1.5-112.1-.1-.8-.1-1.4-.8-1.4-1.6.1-.8.8-1.4 1.6-1.4 19 1.6 53.8 3 111.7.1 2.1-.1 2.9-.1 3.2-.1 4.4 0 6.7 7.2 6.7 14.3s-2.3 14.3-6.7 14.3c-.2 0-.9 0-2.2-.1-42.3-2.1-82.3-2.1-112.7.1h-.2z"
        />
        <circle cx="134.7" cy="65.4" r="3.2" />
        <circle cx="133.9" cy="87.2" r="3.2" />
        <path
          fill="currentColor"
          d="M157.9 109.1c-17.1 0-31-13.9-31-31 0-8.3 3.2-16.1 9.1-21.9.6-.6 1.5-.6 2.1 0s.6 1.5 0 2.1c-5.3 5.3-8.2 12.3-8.2 19.8 0 15.5 12.6 28 28 28s28-12.6 28-28-12.6-28-28-28c-4.8 0-9.5 1.2-13.6 3.5-.7.4-1.6.1-2-.6-.4-.7-.1-1.6.6-2 4.6-2.6 9.8-3.9 15.1-3.9 17.1 0 31 13.9 31 31s-14 31-31.1 31zm0-6.1c-13.7 0-24.9-11.2-24.9-24.9 0-7.4 3.3-14.4 9-19.1.6-.5 1.6-.4 2.1.2.5.6.4 1.6-.2 2.1-5 4.2-7.9 10.3-7.9 16.8 0 12.1 9.8 21.9 21.9 21.9s21.9-9.8 21.9-21.9c0-12.1-9.8-21.9-21.9-21.9-3 0-6 .6-8.7 1.8-.8.3-1.6 0-2-.8-.3-.8 0-1.6.8-2 3.1-1.4 6.5-2.1 9.9-2.1 13.7 0 24.9 11.2 24.9 24.9 0 13.8-11.2 25-24.9 25z"
        />

        <path
          fill="currentColor"
          d="M133.3 50h-10.5l-8.5-13.5 7.1-8.7h13.3l7.1 8.7-8.5 13.5zm-8.8-3h7.2l6.5-10.2-4.8-5.9h-10.5l-4.8 5.9 6.4 10.2z"
        />
        <path
          fill="currentColor"
          d="M85.2 90.7c-4.4 0-6.7-7.2-6.7-14.3s2.3-14.3 6.7-14.3 6.7 7.2 6.7 14.3-2.3 14.3-6.7 14.3zm0-25.6c-1.5 0-3.7 4.5-3.7 11.3s2.2 11.3 3.7 11.3 3.7-4.5 3.7-11.3-2.2-11.3-3.7-11.3z"
        />
        <path
          fill="currentColor"
          d="M164.6 50h-10.5l-8.5-13.5 7.1-8.7H166l7.1 8.7-8.5 13.5zm-8.8-3h7.2l6.5-10.2-4.8-5.9h-10.5l-4.8 5.9 6.4 10.2zm-15.9-8.8h-23.8c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5h23.8c.8 0 1.5.7 1.5 1.5s-.6 1.5-1.5 1.5z"
        />
        <path
          fill="currentColor"
          d="M171.3 38.2h-23.8c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5h23.8c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5z"
        />
        <path d="M87 88.2c2.7-2.9 4.1-19.5.1-18.4-4.1 1.1-1.2 10.6-1.2 10.6" />
        <path
          fill={WHITE}
          stroke={WHITE}
          transform="scale(1 0.85) translate(0, 13.5)"
          d="M175 65.9l15.6-.7-1 22.3-13.6-.6z"
        />
        <path
          fill="currentColor"
          d="M87 89.7c-.4 0-.7-.1-1-.4-.6-.6-.6-1.5-.1-2.1 1.2-1.3 2.5-7.8 2.1-12.7-.1-2-.5-3-.7-3.3-.2.1-.4.2-.5.5-.9 1.7-.2 5.9.5 8.2.2.8-.2 1.6-1 1.9-.8.2-1.6-.2-1.9-1-.2-.7-2.1-7.2-.2-10.5.6-1 1.4-1.7 2.5-2 1.3-.4 2.5.2 3.3 1.4 2.4 4 .8 16.7-1.8 19.5-.4.4-.8.5-1.2.5z"
        />
      </g>
    </svg>
  ),
};
